(function () {
	function replaceCardAddToCart() {
		var cards = document.querySelectorAll('.tps__product-item[data-contact-for-price="true"]');
		if (!cards.length) return;

		cards.forEach(function (card) {
			var url = card.getAttribute('data-product-url');
			if (!url) return;

			var addButtons = card.querySelectorAll('button.add-product-cart-btn, button.tp-product-list-add-to-cart-btn');
			addButtons.forEach(function (button) {
				var link = document.createElement('a');
				link.href = url;
				link.className = button.className.replace(/\badd-product-cart-btn\b/g, '').trim();
				if (link.className) {
					link.className += ' tp-contact-price-view-btn';
				} else {
					link.className = 'tp-contact-price-view-btn';
				}
				link.setAttribute('role', 'button');
				link.setAttribute('aria-label', 'View Product');
				link.textContent = 'View Product';
				button.replaceWith(link);
			});

			var tooltips = card.querySelectorAll('.tp-product-tooltip');
			tooltips.forEach(function (tooltip) {
				tooltip.textContent = 'View Product';
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', replaceCardAddToCart);
	} else {
		replaceCardAddToCart();
	}

	document.addEventListener('shopify:section:load', replaceCardAddToCart);
})();
